const typesMetodosPago = {
    MSI: 'msi',
    CONTADO: 'contado',
    CREDITO: 'credito'
};

export default typesMetodosPago;